import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { useDispatch, useSelector } from 'react-redux'
import {
  ERROR_ACTION,
  GET_ID_VERIFICATION_SUCCESS,
  LOAD_ACTION,
  MANUALLY_VERIFY_ID_SUCCESS,
  SEND_VERIFICATION_INVITE_SUCCESS,
} from './IDVerificationPopUpConstants'
import { getErrorMessage } from './IDVerificationPopUpActions'
import { apiErrorCodes } from '../../utils/apiHelper'
import { getIDVerification } from './IDVerificationPopUpThunk'

const IDVerificationPopUpListener = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tabId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onOpenFileVerification,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSetLoading,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setToastMessage,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onClosePopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onCloseConfirmationPopUps,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action) => {
          switch (action.type) {
            case LOAD_ACTION:
              onSetLoading(true)
              break
            case GET_ID_VERIFICATION_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.tabId === tabId || patientId === action.extraData.patientId) {
                onSetLoading(false)
                // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                onOpenFileVerification({ ...action.payload, PatientId: action.extraData.patientId })
              }
              break
            case MANUALLY_VERIFY_ID_SUCCESS:
            case SEND_VERIFICATION_INVITE_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (patientId === action.extraData.patientId) {
                onClosePopUp()
                onSetLoading(false)
              }
              break
            case ERROR_ACTION:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (patientId === action.extraData.patientId && action.payload.ErrorCode === apiErrorCodes.FORBIDDEN) {
                onCloseConfirmationPopUps()
                getIDVerification(patientId, tabId)
              }
              onSetLoading(false)
              setToastMessage(getErrorMessage(action))
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [patientId])

  return null
}

export default IDVerificationPopUpListener
